import React, { Component } from "react";
import "./HeaderShare.css";
import {
  Facebook,
  Twitter,
  Instagram,
  Share,
  Close
} from "../../General/Svgs/SVGs";
import { prefix } from "../../../scripts/helpers/constants";

class HeaderShare extends Component {
  state = {
    open: false
  };

  collapseClicked = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    return (
      <div
        className={
          prefix +
          "-c-header-share " +
          (this.state.open ? "header-share-open" : "header-share-close")
        }
      >
        <div className="header-share-main-out" onClick={this.collapseClicked}>
          {!this.state.open ? (
            <Share reference="svg-icon header-share-icon-out" />
          ) : (
            <Close reference="svg-icon header-share-icon-out" />
          )}
        </div>
        <div className="header-share-main-in">
          <a
            className="header-share-icons-link"
            target="_blank"
            href={this.props.reference.facebook}
            onClick={this.collapseClicked}
          >
            <Facebook reference="svg-icon header-share-icons" />
          </a>
          <a
            className="header-share-icons-link"
            target="_blank"
            href={this.props.reference.twitter}
            onClick={this.collapseClicked}
          >
            <Twitter reference="svg-icon header-share-icons" />
          </a>
          <a
            className="header-share-icons-link"
            target="_blank"
            href={this.props.reference.instagram}
            onClick={this.collapseClicked}
          >
            <Instagram reference="svg-icon header-share-icons" />
          </a>
        </div>
      </div>
    );
  }
}

export default HeaderShare;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderShare/HeaderShare.js